import { Component, Input, Output, EventEmitter, NgModule, ViewChild } from '@angular/core';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent {

  dropdownData: DropdownValues;
  selectedValuesTexts: string[] = [];

  private predefinedSelectedValues: any[] = [];

  @Input() set selectedValues(values: any[]) { 
    this.predefinedSelectedValues = values;

    if (this.dropdownData && this.dropdownData.values && this.dropdownData.values.length > 0) {
      this.selectedValuesTexts = this.dropdownData.values.filter(item => values.indexOf(item.value) > -1).map(item => item.text);
    }
  }
  @Input() set data(data: DropdownValues) {
    this.dropdownData = data; 

    if (this.dropdownData && this.dropdownData.values && this.predefinedSelectedValues && this.predefinedSelectedValues.length > 0) {
      this.selectedValuesTexts = this.dropdownData.values.filter(item => this.predefinedSelectedValues.indexOf(item.value) > -1).map(item => item.text);
    }
  };

  @Input() disabled: boolean = false;

  @Output() selectionChanged = new EventEmitter<any[]>();

  @ViewChild('dropDown')
  dropDown: DxDropDownBoxComponent;

  selectionChangedHandler(event: any) {
    if (this.dropdownData.selectionMode === DropdownSelectionMode.single) {
      this.dropDown.instance.close();
    }

    if (event.selectedRowKeys && event.selectedRowKeys.length) {
      this.selectionChanged.emit(event.selectedRowKeys.map(item => item.value));
      this.selectedValuesTexts = event.selectedRowKeys.map(item => item.text);
    }
  }
}

import {
  DxTemplateModule,
  DxAutocompleteModule,
  DxButtonModule,
  DxDropDownBoxModule,
  DxTreeViewModule,
  DxDataGridModule,
  DxDropDownBoxComponent,
} from 'devextreme-angular';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [DropdownComponent],
  exports: [DropdownComponent],
  imports: [DxAutocompleteModule, DxTemplateModule, DxButtonModule, DxDropDownBoxModule,
    DxTreeViewModule, DxDataGridModule, CommonModule]
})
export class DropdownModule { }

export class DropdownValues {
  displayName: string = "";
  values: DropdownValue[] = [];
  selectionMode: DropdownSelectionMode;
  showClearButton: boolean;
}

export class DropdownValue {
  constructor(public value: any, public text: string) { }
}

export enum DropdownSelectionMode {
  single = 'single',
  multiple = 'multiple'
}
